import {mapGetters, mapState} from "vuex";

export const userInfoMixin = {
  data: ()=> ({
    selectedMember: null,
  }),
  computed: {
    ...mapGetters({
      isAdmin: 'user/isAdmin',
      isSuperAdmin: 'user/isSuperAdmin',
    }),
    ...mapState({
      member: ({ user: {user} }) => (user.company === null ? null : {id: user.company.id, company_name: user.company.company_name}),
      loggedInUser: ({ user: {user} }) => user,
    })
  },
  created() {
    if (this.can('memberadmin|member')) {
      this.selectedMember = {
        id: this.member.id,
        company_name: this.member.company_name,
      }
    }
  },
}
